module.exports = __webpack_public_path__ + "static/img/row4.58a1595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/mobile/row4.png
// module id = /pwb
// module chunks = 12